import { createClient } from '@supabase/supabase-js';

/** Project base URL only — never include /rest/v1 (the client adds API paths). */
function normalizeSupabaseUrl(raw) {
  return String(raw || '')
    .trim()
    .replace(/\/rest\/v1\/?$/i, '')
    .replace(/\/+$/, '');
}

export const supabaseUrl = normalizeSupabaseUrl(import.meta.env.VITE_SUPABASE_URL);
export const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();

// Fail loudly during dev if env is missing — silent failure = hours of debugging later
if (!supabaseUrl || !supabaseAnonKey) {
   
  console.error(
    '[ORIN] Missing Supabase env variables.\n' +
      'Create a .env file at project root with:\n' +
      '  VITE_SUPABASE_URL=...\n' +
      '  VITE_SUPABASE_ANON_KEY=...\n' +
      'Then restart `npm run dev`.',
  );
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});